import Article from './articles/Article';
import DashboardSideMenu from './DashboardSideMenu';

const Dashboard = () => {
  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-12 h-screen">
        {/* Sidebar (Menú) */}
        <aside className="col-span-3 bg-gray-200 text-cyan p-4 p-2">
          <nav className="space-y-3">
          <DashboardSideMenu></DashboardSideMenu>
          </nav>  
        </aside>

        {/* Contenido Principal */}
        <main className="col-span-9 p-6 bg-gray-100">
            <Article />
        </main>
      </div>
    </div>
    )
}

export default Dashboard
